import DrawerTitle from "@/components/Drawer/TitleHeader";
import { BACKDROP_TRANSITION, DRAWER_TRANSITION, animatedBackdrop, animtedStyleProps } from "@/components/Drawer/utils";
import { SafeAreaView } from "@/components/SafeArea";
import { ThemeMotiPressable, ThemeMotiView, View } from "@/components/Theme";
import { elements } from "@/constants/Styles";
import { DrawerProvider } from '@/context/DrawerContext';
import { useWindowStore } from '@/stores/useWindowStore';
import { Line } from '@/utils/Line';
import TapDetector from '@/utils/TapDetector';
import { useIsFocused } from "@react-navigation/native";
import isEqual from 'lodash/isEqual';
import { memo, useEffect, useMemo } from "react";
import { Modal, StyleSheet } from "react-native";
import { ScrollView } from "react-native-gesture-handler";

const Drawer = (props) => {
    const isMobile = useWindowStore((s) => s.isMobile);
    const { width:windowWidth, height:windowHeight } = useWindowStore((s) => s.dimensions);
    
    const focused = useIsFocused();
    
    
    const MIN_WIDTH = isMobile ? windowWidth*0.9 : 500;

    const {
        name = null,
        title = null, 
        position = 'left', 
        width = isMobile ? windowWidth*0.9 : 250, 
        children = null,
        isOpen = false,
        onClose = () => {},
        backdrop = true,
        backdropClose = true,
        ignoreSafeArea = false,
        scrollview = true,
        customProps : {style:drawerStyle = {}} = {}
    } = props ?? {};

    const _width = width < 1 ? windowWidth * width : width;

    const TAKEN_WIDTH = _width < MIN_WIDTH ? MIN_WIDTH : _width;
    
    const animatedStyleConst = useMemo(() => animtedStyleProps(position, TAKEN_WIDTH), [position, TAKEN_WIDTH]);

    const animatedBackdropStyleConst = useMemo(() => animatedBackdrop(position, windowWidth), [position, windowWidth]);

    const InnerView = ignoreSafeArea ? View : SafeAreaView;

    useEffect(() => {
        if (!focused)
            onClose();
    }, [focused])

    if (!isOpen) {
        return <></>;    
    }

    return (
        <TapDetector>
            <Modal transparent name={'drawer_' + name}>
                <DrawerProvider value={{onClose}}>
                    <ThemeMotiView
                        style={[styles.base, {windowHeight, width: TAKEN_WIDTH}, drawerStyle]}
                        light={drawerStyle?.backgroundColor?.light ?? null}
                        dark={drawerStyle?.backgroundColor?.dark ?? null}
                        transition={DRAWER_TRANSITION}
                        from={ animatedStyleConst.from}
                        animate={ animatedStyleConst.to }
                        aria-label="Drawer"
                    >
                        <InnerView top bottom style={{flex: 1}}>
                            {title?.length > 0 &&
                                <>
                                    <DrawerTitle title={title} onClose={onClose} />
                                    <Line my={15} />
                                </>
                            }


                            {scrollview
                                ?   <ScrollView>
                                        {children}
                                    </ScrollView>
                                :   children
                            }
                        </InnerView>
                    </ThemeMotiView>
                    
                    
                    {backdrop &&
                        <ThemeMotiPressable
                            reduceMotion 
                            style={styles.backdrop}
                            light={'rgba(0,0,0,0.5)'}
                            dark={'rgba(0,0,0,0.5)'}
                            transition={BACKDROP_TRANSITION}
                            from={ animatedBackdropStyleConst.from }
                            animate={ animatedBackdropStyleConst.to }
                            onPress={backdropClose ? onClose : null}
                        />
                    }
                </DrawerProvider>
            </Modal>
        </TapDetector>
    );


};

const styles = StyleSheet.create({
    base: {
        ...StyleSheet.absoluteFillObject,
        zIndex: 500,
        padding: 25,
        flexDirection: 'column',
        ...elements.shadow
    },
    backdrop: {
        ...StyleSheet.absoluteFill,
        width: '100%',
        height: '100%',
        zIndex: 1,
    },
});

export default memo(Drawer, isEqual);